import { createElement } from 'react';
import SidebarMenuPMD from '../SidebarMenuPMD';
var customSidebars = {
  SidebarMenuPMD: SidebarMenuPMD
};
var renderCustomSidebar = function renderCustomSidebar(sidebar, props) {
  var hasSidebar = sidebar && customSidebars[sidebar];
  return hasSidebar ? createElement(customSidebars[sidebar], props) : null;
};
export default renderCustomSidebar;